<template>
  <el-tabs tab-position="left" :value="$lang('timeSelect.今天')">
    <el-tab-pane :label="item.title" v-for="(item,index) in tabsList" :key="index" :name="item.title">
      <ul class="el-scrollbar__view el-select-dropdown__list">
         <li v-for="(li,i) in item.list" :key="i" :class="{'el-select-dropdown__item':true, 'selected': li.value === value, 'is-disabled': li.disabled }" @click="handleSelect(li)"><span>{{ li.label }}</span><i class="el-icon-check" v-if="li.value === value"></i></li>
      </ul>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
// import axios from 'axios';
import emitter from './emitter';

const escapeRegexpString = (value = '') => String(value).replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
const getZero = (num) => {
      // 单数前面加0
      if (parseInt(num) < 10) {
        num = '0' + num;
      }
      return num;
}

export default {
    name: 'associate-column',
    inject: ['select', 'timeSelect'],
    mixins: [emitter],
    props: {
        created: Boolean,
        valueKey: [String, Number],
        labelKey: [String, Number],
        showHeader: {
            type: Boolean,
            default: false
        },
        tableData: {
            type: Array,
            default() {
                return [];
            }
        },
        columns: {
            type: Array,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: () => {
                return [];
            }
        }
    },
    data() {
        return {
            value: '',
            label: '',
            groupDisabled: false,
            visible: true,
            loading: false,
            timeRanges:['随时','09:00 - 13:00','13:00 - 17:00', '17:00 - 21:00'],
            now: new Date(),
            tabsList: []
        };
    },
    watch: {
        currentLabel() {
            this.dispatch('ElSelect', 'setSelected');
        },
        tableData(val) {
            this.formatOptions(val, 'change');
        },
        selectLabel(val) {
            // if (this.labelKey && this.labelKey !== this.valueKey) {
            //     if (this.select.selected.value === val) {
            //     } else {
            //     }
            // };
        }
    },
    computed: {
        currentLabelKey() {
            return this.labelKey || this.valueKey;
        },
        currentLabel() {
            return this.label || (this.isObject ? '' : this.value);
        },
        selectLabel() {
            // return this.labelKey && this.labelKey !== this.valueKey && this.select.selected.currentLabel === this.select.selected.value;
            return this.select.selected.currentLabel;
        }
    },
    created() {
        this.initTimeRanges();
        this.formatOptions(this.tabsList, 'creat');
        this.$on('queryChange', this.queryChange);
        this.$on('handleGroupDisabled', this.handleGroupDisabled);
    },
    methods: {
        initTimeRanges(){
          const tomorrow = new Date(this.now.getTime() + 24*60*60*1000);
          const afterTomorrow = new Date(this.now.getTime() + 24*60*60*1000*2);
          console.log(this.now, tomorrow, afterTomorrow);

          this.tabsList = [
            {title:this.$lang('今天'), list: this.getList(this.now)},
            {title:this.$lang('明天'), list: this.getList(tomorrow)},
            {title:this.$lang('后天'), list: this.getList(afterTomorrow)}
          ]
        },
        getList(time){
          return this.timeRanges.map(item =>{
              const value = this.formatTime(time, item);
              const disabled = this.formatDisabled(time, item);
              const langLabel = item === '随时' ? this.$lang('随时') : item;
              return {label:langLabel, value: value, disabled: disabled }
            });
        },
        formatTime(time, timeRange){
          const suffix = timeRange === '随时'? '09:00 - 21:00': timeRange
          const mon = time.getMonth() + 1;
          return time.getFullYear() + '/' + getZero(mon) + '/' + getZero(time.getDate()) + ' ' + suffix
        },
        formatDisabled(time, timeRange){
          if(time !== this.now){
            return false;
          }
          const h = time.getHours();
          if(timeRange === '随时'){
            if(h < 17){
              return false
            }
          }else{
            const numList = timeRange.split('-').map(item => {
              const text = item.trim().replace(':00');
              return parseInt(text);
            });
            if(h < numList[0]){
              return false
            }
          }
          return true;
        },
        queryChange(query) {
            this.visible = new RegExp(escapeRegexpString(query), 'i').test(this.currentLabel) || this.created;
            if (!this.visible) {
                this.select.filteredOptionsCount--;
            }
        },
        handleGroupDisabled(val) {
            this.groupDisabled = val;
        },
        formatOptions(list, name) {
            if (name === 'change') {
                // list.forEach((item) => {
                //     const obj = {
                //         value: item[this.valueKey],
                //         label: item[this.currentLabelKey],
                //         currentValue: item[this.valueKey],
                //         currentLabel: item[this.currentLabelKey],
                //         data: item,
                //         created: this.created
                //     };
                //     this.changeSelectOptions(obj);
                // });
            } else if (name === 'creat') {
                // this.addSelectOptions(this);
                if (list.length > 0) {
                    list.forEach((li) => {
                      const newList = li.list;
                      newList.forEach(item => {
                        const obj = {
                            value: item.value,
                            label: item.value,
                            currentValue: item.value,
                            currentLabel: item.value,
                            data: item,
                            created: this.created
                        };
                        this.addSelectOptions(obj);
                      })
                    });
                };
            };
        },
        changeSelectOptions(obj) {
            const index = this.select.options.findIndex(item => item.value === obj.value);
            if (index === -1) {
                this.addSelectOptions(obj);
            }
        },
        addSelectOptions(obj) {
            this.select.options.push(obj);
            this.select.cachedOptions.push(obj);
            this.select.optionsCount++;
            this.select.filteredOptionsCount++;
        },
        handleSelect(row, column, event) {
          if(!row.disabled){
            this.value = row.value;
            this.label = row.value;
            this.$emit('rowClick', row);
            this.dispatch('ElSelect', 'handleOptionClick', [this, true]);
          }
        }
    }
};

</script>
<style scoped>
.el-icon-check{
  margin-left: 10px;
  font-size: 18px;
}
</style>
